<template>
  <div class="relative">
    <button
      type="button"
      @click.stop="open = !open"
      class="flex-shrink-0 inline-flex items-center gap-1 pl-1.5 pr-1 py-1.5 sm:py-1 rounded-md border transition-colors"
      :class="open
        ? 'border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-800'
        : 'border-transparent sm:hover:border-gray-200 dark:sm:hover:border-gray-700 sm:hover:bg-gray-50 dark:sm:hover:bg-gray-800'"
      :aria-label="`Priority: ${meta.label}. Click to change.`"
    >
      <svg class="w-3.5 h-3.5 flex-shrink-0" :class="meta.text" fill="currentColor" viewBox="0 0 20 20">
        <path d="M3 2a1 1 0 0 1 1-1h.01a1 1 0 0 1 .99.883L5.01 2H14a1 1 0 0 1 .8 1.6L12.25 7l2.55 3.4A1 1 0 0 1 14 12H5v6a1 1 0 1 1-2 0V2z"/>
      </svg>
      <span class="text-[13px] sm:text-xs font-medium whitespace-nowrap" :class="meta.text">{{ meta.label }}</span>
      <svg class="w-3 h-3 text-gray-300 dark:text-gray-600 flex-shrink-0" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"/>
      </svg>
    </button>

    <div v-if="open" @click="open = false" class="fixed inset-0 z-20"></div>
    <Transition name="row-dropdown">
      <div v-if="open" @click.stop class="absolute right-0 top-full mt-1.5 w-40 sm:w-36 py-1 bg-white dark:bg-[#2A3037] border border-gray-100 dark:border-gray-700 rounded-lg shadow-lg z-30">
        <button
          v-for="p in PRIORITY_ORDER" :key="p"
          type="button"
          @click="choose(p)"
          class="w-full flex items-center gap-2 px-3 py-2.5 sm:py-1.5 text-[13px] sm:text-xs font-medium text-left transition-colors"
          :class="p === priority ? 'bg-gray-50 dark:bg-gray-800 text-gray-900 dark:text-white' : 'text-gray-700 dark:text-gray-200 sm:hover:bg-gray-50 dark:sm:hover:bg-gray-800'"
        >
          <svg class="w-3.5 h-3.5 flex-shrink-0" :class="PRIORITY_META[p].text" fill="currentColor" viewBox="0 0 20 20">
            <path d="M3 2a1 1 0 0 1 1-1h.01a1 1 0 0 1 .99.883L5.01 2H14a1 1 0 0 1 .8 1.6L12.25 7l2.55 3.4A1 1 0 0 1 14 12H5v6a1 1 0 1 1-2 0V2z"/>
          </svg>
          {{ PRIORITY_META[p].label }}
          <svg v-if="p === priority" class="w-3 h-3 ml-auto text-blue-600 flex-shrink-0" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/>
          </svg>
        </button>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { PRIORITY_META, PRIORITY_ORDER, priorityMeta } from './taskPriorities.js'

const props = defineProps({ priority: { type: String, default: 'medium' } })
const emit = defineEmits(['update'])

const open = ref(false)
const meta = computed(() => priorityMeta(props.priority))

function choose(p) {
  open.value = false
  if (p !== props.priority) emit('update', p)
}
</script>

<style scoped>
.row-dropdown-enter-active {
  transition: opacity 0.12s ease, transform 0.14s cubic-bezier(0.2, 0, 0.2, 1);
}
.row-dropdown-enter-from {
  opacity: 0;
  transform: translateY(-4px) scale(0.97);
}
.row-dropdown-leave-active {
  transition: opacity 0.1s ease;
}
.row-dropdown-leave-to {
  opacity: 0;
}
</style>
